import React from "react";
import { useSelector } from "react-redux";
import { useIsLoggedIn } from "@dynamic-labs/sdk-react-core";
import isNil from "lodash.isnil";

import { useWeb3Query } from "@/hooks";
import { Contract, ContractFunc } from "@/types";
import { RootState } from "@/store";
import { useWalletInstance } from "@/contexts/WalletContext";

export const useUpdateBalance = () => {
  const isLoggedIn = useIsLoggedIn();
  const { walletInstance } = useWalletInstance();
  const { walletAddress } = useSelector((state: RootState) => state.wallet);
  const [getUsdcBalance] = useWeb3Query<string>(ContractFunc.GET_USDC_BALANCE);

  React.useEffect(() => {
    let intervalId: NodeJS.Timeout;
    const callAsync = async (): Promise<void> => {
      try {
        await getUsdcBalance(Contract.USDC);
      } catch (error) {
        console.error("Error fetching USDC balance:", error);
      }
    };
    if (isLoggedIn && walletAddress && !isNil(walletInstance)) {
      callAsync();
      intervalId = setInterval(callAsync, 7000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
    // TODO: figure out how to remove walletInstance from the dependency array
  }, [isLoggedIn, walletAddress, walletInstance]);
};
